import ValidationRegistration from './ValidateRegistration'

export default ValidationRegistration
